<script setup>
definePage({
  meta: {
    layout: 'default',
    action: 'fill',
    subject: 'Checklist',
  },
})

const page = {
  groupTitle: 'Checklist & Inspeksi',
  icon: 'ri-checkbox-multiple-line',
  color: 'success',
  title: 'Isi Checklist Harian',
  description: 'Mengisi checklist APAR, kebersihan, hand hygiene, dan checklist rutin lainnya.',
  purpose: 'Panduan langkah demi langkah mengisi checklist inspeksi harian/berkala di unit Anda.',
  concept: [
    {
      icon: 'ri-file-list-3-line',
      title: 'Template vs Hasil Isian',
      text: 'Template checklist (daftar pertanyaan) dibuat sekali oleh admin dan dipakai berulang kali. Setiap kali Anda mengisi, itu menghasilkan satu "hasil isian" baru — template-nya sendiri tidak pernah berubah.',
    },
    {
      icon: 'ri-question-answer-line',
      title: 'Tiga Jenis Jawaban',
      text: 'Setiap item checklist punya salah satu dari tiga jenis jawaban: Ya/Tidak, Skor angka, atau Teks bebas — jenisnya sudah ditentukan saat template dibuat, Anda tinggal mengisi sesuai jenisnya.',
    },
  ],
  steps: [
    { title: 'Buka menu Checklist & Inspeksi, pilih template yang ingin diisi', detail: 'Mis. "APAR" atau "Kebersihan Ruangan".' },
    { title: 'Isi setiap item satu per satu', detail: 'Item Ya/Tidak pakai tombol toggle, item Skor isi angka, item Teks isi keterangan bebas.' },
    { title: 'Pastikan seluruh item sudah dijawab', detail: 'Tombol "Simpan" baru aktif setelah semua item terisi.' },
    { title: 'Klik "Simpan"', detail: 'Setelah tersimpan, Anda bisa langsung melampirkan foto sebagai bukti lewat tombol Evidence yang muncul.' },
  ],
  tips: [
    'Isi checklist di lokasi kejadian langsung, jangan menunda — supaya jawaban akurat.',
    'Kalau menjawab "Tidak" pada checklist MFK (mis. APAR kadaluarsa), sistem otomatis membuat Task tindak lanjut untuk Anda — lihat panduan Checklist MFK.',
  ],
  faq: [
    { q: 'Bisakah saya mengubah jawaban setelah disimpan?', a: 'Tidak — hasil isian checklist bersifat final begitu disimpan, ini menjaga riwayat inspeksi tetap akurat. Kalau memang salah isi, isi ulang sebagai isian baru dan catat di kolom keterangan.' },
    { q: 'Kenapa saya tidak bisa memilih template tertentu?', a: 'Setiap template biasanya sudah ditentukan siapa saja yang boleh mengisi — hubungi Ketua Tim Mutu kalau Anda merasa seharusnya punya akses.' },
  ],
  related: [
    { title: 'Kelola Template Checklist', sub: 'Membuat daftar pertanyaan checklist', icon: 'ri-file-list-3-line', color: 'primary', to: { name: 'help-checklist-kelola-template-checklist' } },
    { title: 'Checklist MFK', sub: 'Checklist fasilitas dengan tindak lanjut otomatis', icon: 'ri-building-2-line', color: 'secondary', to: { name: 'help-fasilitas-checklist-mfk' } },
  ],
}
</script>

<template>
  <GuidePageLayout v-bind="page" />
</template>
